(function ($) {
    $(function () {
        var $window = $(window);

        // make sure filters and search are cleared
        $('#prog-filter-kw, #prog-filter-kw-grad, #prog-filter-kw-grad-new').val('');
        $('#prog-filter-school, #prog-filter-type, #prog-filter-location, #prog-filter-degree, #prog-filter-school-grad-new, #prog-filter-location-grad-new, #prog-filter-degree-grad-new, #prog-filter-degree-undergrad').val('all');

        var tableUndergrad = $('#prog-results-undergrad'),
            tableGradNew = $('#prog-results-grad-new'),
            tableGrad = $('#prog-results-grad');

        // finds visible rows and marks them as active and highlighted (if they are odd)
        var updateRows = function (table) {
            var rows = table.find('tbody tr'),
                visibleRows = rows.filter(':visible'),
                noResults = table.siblings('.no-results'),
                aClass = 'active',
                hClass = 'highlight';

            rows.removeClass(aClass + ' ' + hClass);

            visibleRows.each(function (idx, itm) {
                $itm = $(itm);

                $itm.addClass(aClass);

                if (idx % 2 == 0) $itm.addClass(hClass);
            });

            if (visibleRows.length == 0) { noResults.show() }
            else { noResults.hide() }
        }

        var refreshTables = function () {
            updateRows(tableUndergrad);
            updateRows(tableGradNew);
            updateRows(tableGrad);
            //$(window).resize();
        }

        tableUndergrad.footable(
          {
              "breakpoints": {
                  "tablet": 750
              },
              "filter": {
                  "minimum": 1
              }
          }
        ).bind(
          {
              'footable_filtered': function (e) {
                  updateRows(tableUndergrad);
                  //$window.trigger('resize');
                  $('#prog-filter-school, #prog-filter-type, #prog-filter-degree-undergrad').trigger('change');
              }
          }
        );

        // create "no results" block
        $('<div class="no-results">No results found.</div>').insertAfter(tableUndergrad).hide();

        tableGradNew.footable(
          {
              "breakpoints": {
                  "tablet": 750
              },
              "filter": {
                  "minimum": 1
              }
          }
        ).bind(
          {
              'footable_filtered': function (e) {
                  updateRows(tableGradNew);
                  //$window.trigger('resize');
                  $('#prog-filter-school, #prog-filter-degree, #prog-filter-location').trigger('change');
              }
          }
        );

        // create "no results" block
        $('<div class="no-results">No results found.</div>').insertAfter(tableGradNew).hide();

        tableGrad.footable(
          {
              "breakpoints": {
                  "tablet": 750
              },
              "filter": {
                  "minimum": 1 
              }
          }
        ).bind(
          {
              'footable_filtered': function (e) {
                  updateRows(tableGrad);
                  //$window.trigger('resize');
                  $('#prog-filter-location, #prog-filter-degree').trigger('change');
              }
          }
        );

        // create "no results" block
        $('<div class="no-results">No results found.</div>').insertAfter(tableGrad).hide();

        refreshTables();

        var bindDynamicFilters = function (field, dataAttr, fClass, parent) {
            $(field).on('change', function () {
                var allRows = $(parent + ' .prog-result'),
                    selected = $(field).val(),
                    visibleRows = allRows.not('.footable-filtered, .no-results');

                if (selected != 'all') {
                    // user has selected a filter

                    visibleRows.each(function (idx, itm) {
                        var item = $(itm),
                            itmData = item.attr(dataAttr);

                        // add class that will be removed if found to be in results
                        item.addClass(fClass);

                        // compare data on item to what is toggled in filters
                        $.each(itmData.split(','), function (idx, val) {
                            if (val == selected) {
                                item.removeClass(fClass);
                                return false;
                            }
                        });
                    });
                }
                else {
                    allRows.removeClass(fClass);
                }
                refreshTables();
            });
        }

        bindDynamicFilters('#prog-filter-school', 'data-school', 'prog-result-hidden', '#prog-results-undergrad');
        bindDynamicFilters('#prog-filter-type', 'data-program-types', 'prog-result-hidden', '#prog-results-undergrad');
        bindDynamicFilters('#prog-filter-degree-undergrad', 'data-degrees', 'prog-result-hidden', '#prog-results-undergrad');
        bindDynamicFilters('#prog-filter-location', 'data-locations', 'prog-result-hidden', '#prog-results-grad');
        bindDynamicFilters('#prog-filter-degree', 'data-degrees', 'prog-result-hidden', '#prog-results-grad');
        bindDynamicFilters('#prog-filter-school-grad-new', 'data-school', 'prog-result-hidden', '#prog-results-grad-new');
        bindDynamicFilters('#prog-filter-location-grad-new', 'data-locations', 'prog-result-hidden', '#prog-results-grad-new');
        bindDynamicFilters('#prog-filter-degree-grad-new', 'data-degrees', 'prog-result-hidden', '#prog-results-grad-new');

        // custom select boxes
        $('.prog-filter select').selectric(
          {
              responsive: true,
              arrowButtonMarkup: "<span class='button'></span>",
              disableOnMobile: true
          }
        );

        $('#prog-filter-submit, #prog-filter .search-button').on('click', function () {
            scrollToEl('#prog-results-undergrad');
        });

        $('#prog-filter-submit-grad, #prog-filter-grad .search-button').on('click', function () {
            scrollToEl('#prog-results-grad');
        });

        $('#prog-filter-submit-grad-new, #prog-filter-grad-new .search-button').on('click', function () {
            scrollToEl('#prog-results-grad-new');
        });

        $('th.footable-sortable').on('click', function () {
            refreshTables();
        });

        $window.on('resize', $.throttle(25, true, function () {
            refreshTables();
        }));

        $window.on('load', function () {
            refreshTables();
        });
    })

    $('.programs-of-study-filter-bar-tab').on('click', function () {
        //var selectedType = $(this).attr('data-pos-type');
        //activateTab(selectedType);
        console.log("dawdawd");
    });
})($JQ);

var scrollToEl = function (el, spacing) {
    // set default spacing to 0
    var spacing = spacing || 20;

    if ($JQ(el).length) {
        var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (viewportWidth >= 960) {
            // calculate height of "sticky" elements
            var extra = $JQ('#header').outerHeight(true);
        }
        else {
            extra = 0;
        }

        $JQ('html, body').animate({
            // 20 is extra spacing away from sticky nav
            scrollTop: $JQ(el).offset().top - extra - spacing
        }, 600)
    }
};